import React from 'react';
import { FadeIn } from './Shared';
import { Brain, Shield, Target, Compass, Lock, Zap, Map, Rocket } from 'lucide-react';
export function Solution() {
  const modules = [{
    icon: <Shield className="w-6 h-6 text-brand-teal" data-id="element-137" />,
    title: 'El Protocolo de 72 Horas',
    desc: 'Cómo sobrevivir a los días de abstinencia emocional más agresivos sin recaer.'
  }, {
    icon: <Compass className="w-6 h-6 text-brand-teal" data-id="element-138" />,
    title: 'Auditoría de Identidad',
    desc: 'El inventario paso a paso para recuperar tus talentos, gustos y sueños enterrados.'
  }, {
    icon: <Map className="w-6 h-6 text-brand-teal" data-id="element-139" />,
    title: 'Manual de Logística Independiente',
    desc: 'Guía práctica para tomar el control de tus finanzas y vida legal en Estados Unidos.'
  }, {
    icon: <Rocket className="w-6 h-6 text-brand-teal" data-id="element-140" />,
    title: 'Plan de Vuelo a 90 Días',
    desc: 'Ingeniería inversa para diseñar tus nuevas metas de impacto y éxito personal.'
  }, {
    icon: <Lock className="w-6 h-6 text-brand-teal" data-id="element-141" />,
    title: 'El Escudo de Contacto Cero',
    desc: 'Estrategias digitales y físicas para blindar tu paz mental.'
  }];
  const steps = [{
    num: '1',
    title: 'Ejecutas el Neuro-Reset',
    desc: 'Aplicas las técnicas de sustitución para calmar la ansiedad biológica inmediata.'
  }, {
    num: '2',
    title: 'Blindas tu Logística',
    desc: 'Tomas el control de tu entorno, tus finanzas y tu tiempo con herramientas de autonomía.'
  }, {
    num: '3',
    title: 'Escalas tu Impacto',
    desc: 'Diseñas y ejecutas metas audaces que te devuelven la confianza y el propósito.'
  }];
  return <section className="py-24 bg-brand-cream" data-id="element-142">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-143">
        {/* The Unique Mechanism */}
        <FadeIn data-id="element-144">
          <div className="max-w-3xl mx-auto text-center mb-20" data-id="element-145">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-teal/10 mb-6" data-id="element-146">
              <Brain className="w-8 h-8 text-brand-teal" data-id="element-147" />
            </div>
            <h2 className="text-4xl font-heading text-brand-teal mb-6" data-id="element-148">
              El Método de Neuro-Reset de Dopamina
            </h2>
            <p className="text-xl text-brand-charcoal/80 leading-relaxed" data-id="element-149">
              Este protocolo no te pide que dejes de sentir; te enseña a tratar
              tu dependencia como una desintoxicación bioquímica. En lugar de
              luchar contra la emoción, hackeamos tu sistema nervioso para
              sustituir los estímulos de tu ex por micro-victorias de autonomía
              personal, desactivando el pánico biológico en solo 3 semanas.
            </p>
          </div>
        </FadeIn>

        {/* What You Get */}
        <div className="mb-24" data-id="element-150">
          <FadeIn data-id="element-151">
            <h3 className="text-3xl font-heading text-center text-brand-teal mb-12" data-id="element-152">
              Lo que incluye el protocolo
            </h3>
          </FadeIn>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-153">
            {modules.map((mod, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-154">
                <div className="bg-white rounded-2xl p-8 shadow-sm border border-brand-teal/5 h-full hover:shadow-md transition-shadow" data-id="element-155">
                  <div className="w-12 h-12 rounded-full bg-brand-cream flex items-center justify-center mb-6" data-id="element-156">
                    {mod.icon}
                  </div>
                  <h4 className="text-xl font-bold text-brand-teal mb-3" data-id="element-157">
                    {mod.title}
                  </h4>
                  <p className="text-brand-charcoal/70" data-id="element-158">{mod.desc}</p>
                </div>
              </FadeIn>)}
          </div>
        </div>

        {/* How It Works */}
        <div className="bg-brand-teal rounded-3xl p-8 md:p-16 text-brand-cream relative overflow-hidden" data-id="element-159">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-gold/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-160"></div>
          <FadeIn data-id="element-161">
            <h3 className="text-3xl md:text-4xl font-heading text-center text-brand-gold mb-16 relative z-10" data-id="element-162">
              ¿Cómo funciona?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-163">
              {steps.map((step, i) => <div key={i} className="relative" data-id="element-164">
                  {i !== steps.length - 1 && <div className="hidden md:block absolute top-8 left-1/2 w-full h-0.5 bg-brand-cream/20" data-id="element-165"></div>}
                  <div className="relative z-10 flex flex-col items-center text-center" data-id="element-166">
                    <div className="w-16 h-16 rounded-full bg-brand-gold text-brand-teal flex items-center justify-center text-2xl font-bold font-heading mb-6 shadow-lg" data-id="element-167">
                      {step.num}
                    </div>
                    <h4 className="text-xl font-bold text-brand-cream mb-4" data-id="element-168">
                      {step.title}
                    </h4>
                    <p className="text-brand-cream/80" data-id="element-169">{step.desc}</p>
                  </div>
                </div>)}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}